import React from "react";
import { Link, withRouter } from "react-router-dom";
import CurrencyFormat from "react-currency-format";

import Forex_back_image from "../img/Forex-market.jpg";
import Cryptoearn_Logo from "../img/cryptoearn-cropped2.png";
import Avatar from "../img/avatar-icon.png";
import "./header.css";
import Axios from "axios";

function Header(props) {
  const { state } = props;
  /*setTimeout(()=> {
        props.history.push('/about')
    },2000)*/

  const Logout = () => {
    Axios.get("/logout").then((result) => {
      result.data && window.location.assign('/access/#/login');  /*  props.history.push("/login")  */
    });
  };

  return (
    <div className="header-display">
      <img src={Forex_back_image} alt="back drop" />
      <div className=" header-content">
        <div className="container">
          <div className="header">
            <div className="logo">
              <a href="/">
                <img src={Cryptoearn_Logo} alt="logo" />
              </a>
            </div>
            <div className="header_links">
              <Link className="notification" to="/dashboard/notifications">
                <div className="notify-icon">
                  <i class="far fa-bell">{ 
                    state.user?.notifications.length > 0  && <span className="notify_number">{state.user?.notifications ? state.user?.notifications.length : 0}</span>
                   }</i>
                </div>
              </Link>
              <a href="#" onClick={Logout}>
                logout
              </a>
            </div>
          </div>
        </div>
        <div className="divider"></div>
        <div className="container">
          <div className="profile-content">
            <div>
              {/* <img src={Avatar} alt="avatar" /> */}
              <div>
                <h3>
                  welcome,{" "}
                  <span className="person">
                    {state.user ? state.user.username : null}
                  </span>
                </h3>
                <Link
                  className="Password_change_link parent"
                  to="/dashboard/security"
                >
                  <span>settings</span>
                  <div className="d-content">
                    <ul>
                      <li>
                        <Link
                          className="Password_change_link"
                          to="/dashboard/security"
                        >
                          <button>Change Password</button>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Link>
              </div>
              <br />
              <p className="amount">
                <span>
                  <i class="fas fa-wallet"></i> wallet balance
                </span>
                <CurrencyFormat
                  renderText={(value) => (
                    <>
                      <p>
                        <strong>{value}</strong>
                      </p>
                    </>
                  )}
                  value={state.user ? state.user.wallet : 0}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  thousandSeparator={true}
                  displayType={"text"}
                  prefix={"$"}
                />
              </p>
              <br />
              <div className="header-navigation">
                <div className="nav-links">
                  <Link to="/dashboard/overview">
                    <i className="fas fa-house-user"></i>Dashboard
                  </Link>
                </div>
                <div className="nav-links">
                  <Link to="/dashboard/deposit">
                    <i className="fas fa-money-bill"></i> Deposit
                  </Link>
                </div>
                <div className="nav-links">
                  <Link to="/dashboard/withdraw">
                    <i className="fas fa-coins"></i>Withdraw
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(Header);
